import styled from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const UnitPriceWrapperStyled = styled.div `
  ${getTextStyles('Play', 700, 24, 28)}

  width: 100%;
  display: flex;
  letter-spacing: 0.02em;
  margin-top: ${({ isMarginTop }) => (isMarginTop ? '24px' : 'none')};

  justify-content: space-between;
  flex-direction: column;
  gap: 16px;

  color: ${colorCoreBlack900Base};
  border-top: 1px solid ${colorCoreGray500};
  border-bottom: 1px solid ${colorCoreGray500};
  padding: 18px 0;
`;
export const UnitPriceLabelStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 16, 24)}

  color: ${colorCoreBlack900Base};

  justify-content: flex-start;
`;
export const UnitPriceStyled = styled.span `
  ${getTextStyles('Play', 700, 24, 28)}

  display: flex;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  align-items: center;

  color: ${colorCoreBlack900Base};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: ltr;'}

  ${ADAPTIVE.maxWidth.mobile} {
    flex-direction: column;
    align-items: flex-end;
  }
`;
export const StrikethroughTextStyled = styled.s `
  color: ${colorCoreBlack300};
  display: inline-block;
  padding: 2px 20px 0 0;
  vertical-align: bottom;

  ${getTextStyles('Ubuntu', 400, 16, 24)}

  ${ADAPTIVE.maxWidth.mobile} {
    padding: 0;
  }
`;
export const DisclaimerIconStyled = styled(SVGIcon) `
  margin-top: px;
`;
